export default "__VITE_ASSET__CeviSjSQ__"